###
  Tooltip widget
###

class INTENT.widgets.CampaignIncrease
  @MESSAGE_ID: "campaign_increase_alert"

  @ATTR_NAME: "data-widget-campaign-increase"

  @ATTR_INPUT: "#{@ATTR_NAME}-input"
  @ATTR_ALERT: "#{@ATTR_NAME}-alert"

  constructor: (@el) ->
    @s = @.constructor
    @input = $(document).find "[#{@s.ATTR_INPUT}]"
    @tab = $ '[data-toggle="tab"][href="#basic"]'

    @el.on "click", =>
      @tab.tab 'show'

      @input.val @get_budget()
      @input.showWarning()

      wrapper = @input.closest ".form-group"
      INTENT.utils.Scroller.to wrapper, null, null, 100

      wrapper.find("##{@s.MESSAGE_ID}").remove()
      wrapper.append @get_template_alert()

  get_budget: () =>
    @el.attr @s.ATTR_NAME

  get_message_alert: () =>
    @el.attr @s.ATTR_ALERT

  get_template_alert: () =>
    text = @get_message_alert()

    """
    <div id="#{@s.MESSAGE_ID}" class="help-block text-warning">#{text}</div>
    """